// Base64 Image to Canvas with a Crop
export default function image64toCanvasRef(canvas, image64, crop, canvasSize) {
  return new Promise(resolve => {
    const { width, height } = canvasSize;
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    const image = new Image();

    image.onload = () => {
      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        width,
        height,
      );
      resolve();
    };
    image.src = image64;
  });
}
